import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import AllDayBreakfast from "../../assets/images/main-slider/all-day-breakfast.jpg";
import EnjoiBrunch from "../../assets/images/main-slider/enjoy-brunch.jpg";
import LoungeSection from "../../assets/images/main-slider/lounge-section.jpg";
import Patio from "../../assets/images/main-slider/patio.jpg";
import PrivateRoms from "../../assets/images/main-slider/private-rooms.jpg";
import EggBenedicts from "../../assets/images/main-slider/egg-benedict.jpg";
import HappinesIsHomeMade from "../../assets/images/main-slider/happines-is-home-made.jpg";
import bookicon1 from "../../assets/images/resource/book-icon-transparent.png";
import "swiper/swiper.min.css";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper.min.css";

SwiperCore.use([Navigation]);

const slideLabels = [
    {
        title: "All Day Breakfast",
        title2: "",
        subTitle: "Canmore Restaurant, since 1990",
    },
    {
        title: "Enjoy Brunch",
        title2: "Surrounded By Mountains",
        subTitle: "Featuring 70 comfortable seats",
    },
    {
        title: "Patio",
        title2: "",
        subTitle: "More than 30 seats nestled between 180 degrees of mountain views",
    },
    {
        title: "Private Rooms",
        title2: "",
        subTitle: "For catering",
    },
    {
        title: "Lounge Section",
        title2: "",
        subTitle: "With a fully stocked bar to serve you best",
    },
    {
        title: "Famous Eggs Benedict",
        title2: "",
        subTitle: "With 7 different kinds to choose from, all topped with homemade hollandaise sauce",
    },
    {
        title: "Happines Is Homemade",
        title2: "",
        subTitle: "Hollandaise sauce, François duck liver paté, Creton, and everything in between",
    },
];

function Banner() {
    return (
        <Swiper
            className="banner-section banner-section-coustm"
            loop={true}
            spaceBetween={50}
            slidesPerView={1}
            navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }} // Use "navigation" with lowercase, and place it outside the SwiperSlide elements
        >
            <div className="banner-container">
                <div className="banner-slider">
                    <div className="swiper-wrapper">
                        {[
                            AllDayBreakfast,
                            EnjoiBrunch,
                            Patio,
                            PrivateRoms,
                            LoungeSection,
                            EggBenedicts,
                            HappinesIsHomeMade
                        ].map((image, index) => (
                            <SwiperSlide
                                key={index}
                                className="swiper-slide slide-item img-fluid"
                                style={{
                                    // opacity: 0.6,
                                    backgroundImage: `url(${image})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                }}
                            >
                                <div className="auto-container">
                                    <div className="content-box">
                                        <div className="content content-bg">
                                            <div className="clearfix">
                                                <div className="inner">
                                                    <div className="subtitle">
                                                        <span>
                                                            delightful
                                                            experience
                                                        </span>
                                                    </div>
                                                    <div className="pattern-image">
                                                            <img
                                                                src={
                                                                    require("../../assets/images/icons/separator.svg")
                                                                        .default
                                                                }
                                                                alt="mySvgImage"
                                                            />
                                                        </div>
                                                    <h1>
                                                        <span>
                                                            {
                                                                slideLabels[
                                                                    index
                                                                ].title
                                                            }
                                                            <br />
                                                            {
                                                                slideLabels[
                                                                    index
                                                                ].title2
                                                            }
                                                        </span>
                                                    </h1>
                                                    <div className="text">
                                                        {
                                                            slideLabels[index]
                                                                .subTitle
                                                        }
                                                    </div>
                                                    <div
                                                        className="links-box wow fadeInUp"
                                                        data-wow-delay="0ms"
                                                        data-wow-duration="1500ms"
                                                    >
                                                        <div className="link link-btn">
                                                            <Link
                                                                to="https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu"
                                                                className="theme-btn btn-style-two clearfix"
                                                            >
                                                                <span className="btn-wrap">
                                                                    <span className="text-one">
                                                                        view our
                                                                        menu
                                                                    </span>
                                                                    <span className="text-two">
                                                                        view our
                                                                        menu
                                                                    </span>
                                                                </span>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </div>
                </div>
            </div>
            <div className="swiper-button-prev">
                <span className="fal fa-angle-left"></span>
            </div>
            <div className="swiper-button-next">
                <span className="fal fa-angle-right"></span>
            </div>
            <div className="book-btn">
                <Link to="https://www.opentable.ca/restref/client/?rid=1411912&restref=1411912&lang=en-CA&color=1&r3uid=cfe&dark=false&partysize=6&datetime=2025-08-21T22%3A30&ot_source=Restaurant%20website&corrid=497d104c-c015-4655-bcf6-4abdfe7c9bc0" className="theme-btn">
                    <span className="icon">
                        <img width={70} height={70} src={bookicon1} alt="" title="" />
                    </span>
                    <span className="txt">book a table</span>
                </Link>
            </div>
        </Swiper>
    );
}

export default Banner;
